import { createThemeStore } from '@dak/ui';

export const useThemeStore = createThemeStore({ storageKey: 'tracker-theme' });
